import React from 'react'
import styled from 'styled-components'

// TODO: Move this component to UI Library
const Paragraph = (props) => (
  <StyledParagraph {...props}>
    {props.children}
  </StyledParagraph>
)

export default Paragraph

const StyledParagraph = styled.p`
  display:block;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;
  text-transform: none;
  ${({color}) => (color) ? `color: ${color};` : `color: #010101;`}
  ${({fontSize}) => (fontSize) ? `font-size: ${fontSize};` : `font-size: 12px;`}
  ${({fontWeight}) => (fontWeight) ? `font-weight: ${fontWeight};` : `font-weight: bold;`}
  ${({lineHeight}) => (lineHeight) ? `line-height: ${lineHeight};` : `line-height: 12px;`}
  ${({align}) => (align) ? `text-align: ${align};` : `text-align: center;`}
`



// WEBPACK FOOTER //
// ./src/components/Paragraph/index.js